import OrdersSvg from "./icons/orders.svg";
import PaymentsSvg from "./icons/payments.svg";
import RewardsSvg from "./icons/rewardsnew.svg";
import CovidSvg from "./icons/covid.svg";
import WineSvg from "./icons/wine.svg";
import MarketSvg from "./icons/market.svg";
import AccountSettingSvg from "./icons/accountSettings.svg";
import CouponsSvg from "./icons/coupons.svg";
import CulinarySvg from "./icons/culinary.svg";
import FreshPasssSvg from "./icons/freshPass.svg";
import Shopping from "./icons/shopping.svg";
import AcEmailSvg from "./icons/acEmail.svg";
import ForgotpwdSvg from "./icons/forgotpwd.svg";
import DefaultCard from "./cards/default-card";
import RewardsCard from "./cards/rewards-card";
import OrderCard from "./cards/order-card";
import BannerCard from "./cards/banner-card";
import PaymentsCard from "./cards/payments-card";
import PaymentDetailCard from "./cards/payment-detail-card.jsx";
import FreshPassCard from "./cards/freshpass-card";
import AccountCard from "./cards/account-card";
import EmailCard from "./cards/email-card";
import OrderDetailsCard from "../help/cards/order-details-card";

export const routes = {
  orders: "orders",
  accountsetting: "accounts",
  payments: "payments",
  foryou: "forufaq",
  onlineshopping: "shoppingfaq",
  covid19: "covidfaq",
  wine: "winefaq",
  market: "marketfaq"
};

export const routeTitle = {
  [routes.orders]: "Orders",
  [routes.accountsetting]: "Account Settings",
  [routes.payments]: "Wallet",
  [routes.foryou]: "{banner} for U™ FAQs",
  [routes.onlineshopping]: "Online Shopping FAQs",
  [routes.covid19]: "Covid 19 FAQs",
  [routes.wine]: "Wine program FAQs",
  [routes.market]: "Marketplace FAQs"
};

const BANNER = {
  TOMTHUMB: "tomthumb",
  ALBERTSON: "albertsons",
  VONS: "vons",
  SAFEWAY: "safeway",
  RANDALLS: "randalls",
  PAVILIONS: "pavilions",
  JEWELOSCO: "jewelosco",
  CARRSQC: "carrsqc",
  SHAWS: "shaws",
  STARMARKET: "starmarket",
  ACEMARKETS: "acmemarkets",
  ANDRONICOS: "andronicos",
  HAGGEN:"haggen",
  BALDUCCIS:"balduccis",
  KINGS:"kingsfoodmarkets"
}

export const allCategoryLists = [
  {
    allow: ["guest", "user"],
    Card: OrderCard,
    desc: "Track, edit and cancel recently placed orders.",
    id: 1,
    image: OrdersSvg,
    link: {
      href: "/help/" + routes.orders,
      label: "View all orders",
    },
    title: routeTitle[routes.orders],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    isParent: true,
    topCategory: true,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: AccountCard,
    desc: "Edit settings and other profile information.",
    id: 2,
    image: AccountSettingSvg,
    link: {
      href: "/help/" + routes.accountsetting,
      label: "Update info",
    },
    title: routeTitle[routes.accountsetting],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    isParent: true,
    topCategory: true,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: PaymentsCard,
    desc: "Update or add payment information",
    id: 3,
    image: PaymentsSvg,
    link: {
      href: "/help/payments",
      label: "Manage info",
    },
    title: routeTitle[routes.payments],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: true,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: RewardsCard,
    desc: "Check balance and manage Rewards. ",
    id: 4,
    image: RewardsSvg,
    link: {
      href: "/foru/rewards/reward-history.html",
      label: "View Points history",
    },
    title: "Rewards",
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: true,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: FreshPassCard,
    desc: "Sign up, extend your trial or manage your subscription.",
    id: 5,
    image: FreshPasssSvg,
    link: {
      href: "/lp/subscriptions-delivery.html",
      label: "View details",
    },
    title: "Fresh Pass",
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: DefaultCard,
    desc: "Browse and clip hundreds of coupons and deals",
    id: 6,
    image: CouponsSvg,
    link: {
      href: "/foru-guest.html",
      label: "Clip now",
    },
    title: "Coupons",
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: BannerCard,
    desc: "All questions regarding our program, deals, rewards and perks",
    id: 7,
    image: Shopping,
    link: {
      href: "/help/" + routes.foryou,
      label: "View all FAQs",
    },
    title: routeTitle[routes.foryou],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: true,
  },
  {
    allow: ["guest", "user"],
    Card: DefaultCard,
    desc: "All questions regarding delivery and pickup",
    id: 8,
    image: CulinarySvg,
    link: {
      href: "/help/" + routes.onlineshopping,
      label: "View all FAQs",
    },
    title: routeTitle[routes.onlineshopping],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: true,
  },
  {
    allow: ["guest", "user"],
    Card: DefaultCard,
    desc: "Our measures to help protect you",
    id: 9,
    image: CovidSvg,
    link: {
      href: "/help/" + routes.covid19,
      label: "View all FAQs",
    },
    title: routeTitle[routes.covid19],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.HAGGEN],
    topCategory: false,
    topFaq: true,
  },
  {
    allow: ["user"],
    Card: AccountCard,
    desc: "Change your password on file",
    id: 10,
    image: ForgotpwdSvg,
    link: {
      href: "/account-reset/forgot-password",
      label: "Reset password",
    },
    parentId: 2,
    title: "Forgot password",
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: false,
  },
  {
    allow: ["user"],
    Card: EmailCard,
    desc: "",
    id: 11,
    image: AcEmailSvg,
    link: {
      href: "/customer-account/account-settings.html",
      label: "Update info", // todo ned to update
    },
    parentId: 2,
    title: routeTitle[routes.accountsetting],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: OrderDetailsCard,
    desc: "You have no recent orders",
    id: 12,
    image: OrdersSvg,
    link: {
      href: "/order-account/orders",
      label: "View all orders",
    },
    parentId: 1,
    title: routeTitle[routes.orders],
    topCategory: false,
    topFaq: false,
  },
  {
    allow: ["guest", "user"],
    Card: DefaultCard,
    desc: "All questions regarding our wine program",
    id: 13,
    image: WineSvg,
    link: {
      href: "/help/" + routes.wine,
      label: "View all FAQs",
    },
    title: routeTitle[routes.wine],
    banner: [BANNER.PAVILIONS, BANNER.ALBERTSON, BANNER.VONS, BANNER.SAFEWAY],
    topCategory: false,
    topFaq: true,
  },
  {
    allow: ["guest", "user"],
    Card: DefaultCard,
    desc: "Safeway® Marketplace FAQs",
    id: 14,
    image: MarketSvg,
    link: {
      href: "/help/" + routes.market,
      label: "View all FAQs",
    },
    title: routeTitle[routes.market],
    banner: [BANNER.SAFEWAY],
    topCategory: false,
    topFaq: true,
  },
  {
    allow: ["user"],
    Card: PaymentDetailCard,
    desc: "No card on file",
    id: 17,
    image: PaymentsSvg,
    link: {
      href: "/customer-account/payment.html",
      label: "Add payment",
    },
    parentId: 3,
    title: routeTitle[routes.payments],
    banner: [BANNER.ALBERTSON, BANNER.TOMTHUMB, BANNER.VONS, BANNER.SAFEWAY, BANNER.RANDALLS, BANNER.PAVILIONS, BANNER.JEWELOSCO, BANNER.CARRSQC, BANNER.SHAWS, BANNER.STARMARKET, BANNER.ACEMARKETS, BANNER.ANDRONICOS,BANNER.BALDUCCIS,BANNER.HAGGEN,BANNER.KINGS],
    topCategory: false,
    topFaq: false,
  },
];

export const loginUrl = "/account/sign-in.html";

export const NO_ORDERS = [
  {
    title: "Orders",
    image: OrdersSvg,
    desc: "You have no recent orders",
    link: {
      href: "/order-account/orders",
      label: "View all orders",
    },
    id: 1,
    allow: ["guest", "user"],
    Card: OrderDetailsCard,
  },
];
